import React, { useRef, useState } from 'react';
import { Upload } from 'lucide-react';
import { api } from '../../lib/api';
import { toast } from 'sonner';

export default function UploadButton({
  onUploaded,
  label = 'Yükle',
  tiny = false,
  accept = 'image/*',
  askName = false,
  askCategory = false,
  categorySuggestions = [],
}) {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);

  const onPick = async (e) => {
    const f = e.target.files?.[0];
    if (!f) return;
    e.target.value = '';

    let displayName = '';
    if (askName) {
      const defaultName = f.name.replace(/\.[^.]+$/, '');
      const entered = window.prompt(
        'Bu dosyayı sistemde nasıl adlandırmak istersin? (kendine anlamlı bir ad ver)',
        defaultName,
      );
      if (entered === null) return;
      displayName = entered.trim() || defaultName;
    }

    let category = '';
    if (askCategory) {
      const hint = categorySuggestions.length
        ? `\n\nMevcut kategoriler: ${categorySuggestions.join(', ')}`
        : '\n\n(Örn: "Basın Fotoğrafları", "Sponsor Logoları", "KVKK Belgeleri")';
      const entered = window.prompt(
        `Bu dosyayı hangi kategoriye eklemek istersin? (boş bırakabilirsin)${hint}`,
        '',
      );
      if (entered === null) return;
      category = entered.trim();
    }

    setBusy(true);
    try {
      const res = await api.adminUploadFile(f, displayName, category);
      onUploaded(res.url, res);
      toast.success('Yüklendi: ' + (res.display_name || res.name));
    } catch (err) {
      toast.error(err?.response?.data?.detail || 'Yükleme başarısız');
    } finally {
      setBusy(false);
    }
  };

  if (tiny) {
    return (
      <>
        <button type="button" onClick={() => ref.current?.click()} disabled={busy} className="h-8 px-2 rounded-md text-ink-500 hover:text-ink-700 hover:bg-white transition-colors disabled:opacity-40">
          {busy ? '...' : label}
        </button>
        <input ref={ref} type="file" accept={accept} onChange={onPick} className="hidden" />
      </>
    );
  }

  return (
    <>
      <button type="button" onClick={() => ref.current?.click()} disabled={busy} data-testid="upload-btn" className="bg-ink-600 text-cream rounded-xl px-3 h-10 text-xs font-semibold hover:bg-ink-500 inline-flex items-center gap-1.5 disabled:opacity-60">
        <Upload className="w-3.5 h-3.5" /> {busy ? 'Yükleniyor...' : label}
      </button>
      <input ref={ref} type="file" accept={accept} onChange={onPick} className="hidden" />
    </>
  );
}
